import React, { FC } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { SuccessFilledColor } from '@nbc-design/icons/lib/web/SuccessFilledColor';
import { Link } from '@nbc-design/link';
import { IDENTITY_VALIDATION_STEP_ID } from 'containers/IdentityValidation/config';
import { IdentityVerificationMethod, NON_MODIFIABLE_METHODS } from '../constants';
import IdentityWrapper from '../../IdentityValidation/components/IdentityWrapper';

const DEFAULT_VALIDATION_MESSAGE_KEY = 'validationBankingInfo';

const VALIDATION_MESSAGE_KEYS: Partial<Record<IdentityVerificationMethod, string>> = {
  [IdentityVerificationMethod.ONLINE]: 'validationOnline',
  [IdentityVerificationMethod.MCP]: 'validationMCP',
  [IdentityVerificationMethod.CLRDCHECK]: 'validationCheck',
  [IdentityVerificationMethod.BANKREF]: 'validationBankingInfo',
};

type ValidationCompletedProps = {
  getText: (key: string) => string;
  getIdentityValidationText: (key: string) => string;
  selectedVerificationMethod: string; // The identity verification method selected by the user
  actualIdentityMethod?: string; // The actual identity method used (for alternate verification fallback)
  goToStep: (step: string) => void;
};

const ValidationCompleted: FC<ValidationCompletedProps> = ({
  getText,
  goToStep,
  selectedVerificationMethod,
  actualIdentityMethod,
  getIdentityValidationText,
}) => {
  const canModifyVerificationMethod = !NON_MODIFIABLE_METHODS.includes(
    selectedVerificationMethod as IdentityVerificationMethod,
  );

  const getValidationMessageKey = (): string => {
    // Check if selected method has a direct mapping
    if (VALIDATION_MESSAGE_KEYS[selectedVerificationMethod]) {
      return VALIDATION_MESSAGE_KEYS[selectedVerificationMethod];
    }

    // For alternate verification, check the actual identity method used
    if (actualIdentityMethod && VALIDATION_MESSAGE_KEYS[actualIdentityMethod]) {
      return VALIDATION_MESSAGE_KEYS[actualIdentityMethod];
    }

    return DEFAULT_VALIDATION_MESSAGE_KEY;
  };

  const completedStatusText = getText('completedStatus');
  const extraHeaderElements = (
    <div className="status-wrapper">
      <section className="status">
        <SuccessFilledColor size="medium" title={completedStatusText} className="check-icon" />
        <span className="status-description">{completedStatusText}</span>
      </section>
      {canModifyVerificationMethod && (
        <section className="link-modify-wrapper">
          <Link
            href="#"
            underlined={true}
            className="link-modify"
            onClick={() => goToStep(IDENTITY_VALIDATION_STEP_ID)}
          >
            {getText('modifyLink')}
          </Link>
        </section>
      )}
    </div>
  );

  return (
    <Row>
      <Col xs={12} md={12} lg={12}>
        <IdentityWrapper
          title={getIdentityValidationText('validateTitle')}
          subTitle={getIdentityValidationText(getValidationMessageKey())}
          iconName="selfie"
          hasButton={false}
          extraHeaderElements={extraHeaderElements}
          className="validation-completed"
        />
      </Col>
    </Row>
  );
};

export default ValidationCompleted;
